import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=1c7ad3b0&scoped=true&"
import script from "./LoginForm.vue?vue&type=script&lang=js&"
export * from "./LoginForm.vue?vue&type=script&lang=js&"
import style0 from "./LoginForm.vue?vue&type=style&index=0&id=1c7ad3b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7ad3b0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInput: require('/app/components/UI/UiInput.vue').default,UiInputWrapper: require('/app/components/UI/UiInputWrapper.vue').default,UiButton: require('/app/components/UI/UiButton.vue').default})
